import React from 'react';
import Dialog from '../Dialog/Dialog';
import styles from './FasterProduct.module.less';
import Button from '../SoftButton/SoftButton';
import { setFasterProduct } from '../../actions/layout';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Btn from '../../components/Btn/Btn';
import defaultImag from '../../static/faster_product.svg';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { fasterProductNextTime } from '../../constants/storageKeys';
import { logging } from '../../actions/log';

const selectFasterProduct = createSelector(
  state => state.layout,
  layout => layout.fasterProduct,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default () => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { soft = {}, info, logInfo, record } = useSelector(selectFasterProduct);
  const data = soft.appRecommend;
  useEffect(() => {
    if (data && info && record) {
      localStorage.setItem(
        fasterProductNextTime,
        dayjs()
          .add(1, 'day')
          .format('YYYYMMDD'),
      );
    }
    if (data) {
      dispatch(
        logging({
          category: 'P',
          action: 'Accelerate',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.softId || soft.softID,
            accelerate: data,
            softType: soft.andriodType,
          },
        }),
      );
    }
  }, []);
  const handleClose = type => () => {
    dispatch(setFasterProduct(null));
    if (info && record) {
      localStorage.setItem(
        fasterProductNextTime,
        dayjs()
          .add(7, 'day')
          .format('YYYYMMDD'),
      );
    }
    // 点击X打桩
    if (type !== 'btn') {
      dispatch(
        logging({
          category: 'C',
          action: 'Accelerate_Close',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.softId || soft.softID,
            accelerate: data,
            softType: soft.andriodType,
          },
        }),
      );
    } else {
      // 点击取消按钮打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Accelerate_N',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.softId || soft.softID,
            accelerate: data,
            softType: soft.andriodType,
          },
        }),
      );
    }
  };
  const handleDown = () => {
    dispatch(setFasterProduct(null));
    if (info && record) {
      localStorage.setItem(
        fasterProductNextTime,
        dayjs()
          .add(1, 'day')
          .format('YYYYMMDD'),
      );
    }
    dispatch(
      logging({
        category: 'C',
        action: 'Accelerate_Y',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: soft.softId || soft.softID,
          accelerate: data,
          softType: soft.andriodType,
        },
      }),
    );
  };
  if (!data) {
    return null;
  }
  return (
    <Dialog
      title="联想应用商店温馨提示"
      maskStyle={styles.mask}
      containerStyle={styles.containerStyle}
      handleClose={handleClose('x')}
    >
      <div className={styles.content}>
        <img src={data.logoFile || defaultImag} className={styles.contentLogo} />
        <div className={styles.contentDesc} title={data.recommendDesc}>
          {data.recommendDesc}
        </div>
      </div>
      <div className={styles.button}>
        <Btn className={styles.cancelButton} handleClick={handleClose('btn')}>
          {data.cancelButtonDesc}
        </Btn>

        <Btn className={styles.confirmButton} primary handleClick={handleDown}>
          <Button
            soft={{ ...data, softID: data.softId }}
            info={{
              ...info,
              uninstallClassName: styles.confirmButton,
              installedClassName: styles.confirmButton,
              uninstallText: data.confirmButtonDesc,
              installedText: data.confirmButtonDesc,
            }}
            logInfo={{ ...logInfo }}
          />
        </Btn>
      </div>
    </Dialog>
  );
};
